import { useParams } from "react-router-dom";
import { useState } from "react";
import { useGetTables } from "../../../hooks/api/queries";

const useTableView = () => {
  const { store_id } = useParams();
  const [isLoadingRefresh, setIsLoadingRefresh] = useState(false);
  const [queryParams, setQueryParams] = useState({
    store_id: store_id,
  });

  const {
    isLoading: isLoadingOrderTable,
    data: orderTables,
    refetch: refetchOrderTables,
  } = useGetTables({ params: "", queryParams });

  const handleRefresh = () => {
    setIsLoadingRefresh(true);
    refetchOrderTables();
    setTimeout(() => {
      setIsLoadingRefresh(false);
    }, 1000);
  };

  const handleSearchTables = (value) => {
    const newQueryParams = { ...queryParams };
    if (value?.length === 0) delete newQueryParams.query;
    else newQueryParams.query = value;
    delete newQueryParams.page;
    setQueryParams(newQueryParams);
  };

  const gotoPage = (pageNumber) => {
    const newQueryParams = { ...queryParams };
    newQueryParams.page = pageNumber;
    setQueryParams(newQueryParams);
  };

  return {
    isLoadingOrderTable,
    orderTables: orderTables?.data || [],
    metaDetails: orderTables?.meta | {},
    isLoadingRefresh,
    gotoPage,
    handleRefresh,
    refetchOrderTables,
    handleSearchTables,
  };
};

export default useTableView;
